import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'favouriteMenu';

const favouriteMenuService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  orderData: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderData/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default favouriteMenuService;
